export const invoice_url =
  "https://apiv2-judrztptdq-uc.a.run.app/v1/invoice";
export const ninja_url = "https://ninjavan2-judrztptdq-uc.a.run.app/api";
